import React from 'react';
import ProjectPage from '../../components/projects/ProjectPage';
import m1Data from '../../data/projects/m1.js';

function M1() {
  return <ProjectPage projectData={m1Data} />;
}

export default M1;

